import type {Mapper} from 'framework';
import type {RecentLineIngredient} from '../../domain/recent-line-ingredient';
import type {RecentItemsDto} from '../dto/recent-line-ingredient.dto';

type RecentItemsSuccess = Extract<RecentItemsDto, {data: readonly unknown[]}>;
type RecentItemDto = RecentItemsSuccess['data'][number];

export class RecentItemDtoToRecentLineIngredientMapper implements Mapper<
  RecentItemDto,
  RecentLineIngredient
> {
  transform(dto: RecentItemDto): RecentLineIngredient {
    return {
      id: dto.id,
      origin: dto.origin,
      displayName: dto.displayName,
      nutritionPer100g: dto.nutritionPer100g,
      serving: dto.serving,
      lastUse: {
        quantity: dto.lastUse.quantity,
        unit: dto.lastUse.unit,
        gramEquivalent: dto.lastUse.gramEquivalent,
      },
      macros: {
        kcal: dto.macros.kcal,
        proteinGrams: dto.macros.proteinGrams,
        carbsGrams: dto.macros.carbsGrams,
        fatGrams: dto.macros.fatGrams,
      },
      lastUsedAt: dto.lastUsedAt,
    };
  }
}
